export const SALESFORCE_MATCH_FIRST_TITLE =
    'Match Your Segment to Salesforce First';
export const SALESFORCE_MATCH_FIRST_TEXT =
    `In order to create a Salesforce campaign with this segment's data, \n
    please match your contacts and/or leads from Saleforce.`;
export const SALESFORCE_MATCH_FIRST_BUTTON =
    'Match Segment to Salesforce';
